export const PURCHASE_ORDER_STATUS_PERMISSION = {
  VIEW: 'PURCHASE_ORDER_STATUS_VIEW',
  ADD: 'PURCHASE_ORDER_STATUS_ADD',
  EDIT: 'PURCHASE_ORDER_STATUS_EDIT',
  DEL: 'PURCHASE_ORDER_STATUS_DEL',
};

export const PURCHASE_ORDER_SCOPE_OPTIONS = [
  { value: 0, label: 'Đơn mua hàng' },
  { value: 1, label: 'Đơn hàng trả lại' },
];
